import AttachmentPreferencesOptionState, {
    AttachOrSharePreference,
} from '../store/schema/AttachmentPreferencesOptionState';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';

export interface SelectAttachmentPreferencesOptionState {
    optionState: AttachmentPreferencesOptionState;
}

export default select<SelectAttachmentPreferencesOptionState>({
    optionState: () => store,
})(
    action('selectAttachmentPreferencesOption')(function selectAttachmentPreferencesOption(
        optionKey: keyof AttachmentPreferencesOptionState,
        preference: AttachOrSharePreference,
        state?: SelectAttachmentPreferencesOptionState
    ) {
        let { optionState } = state;
        optionState[optionKey] = preference;
    })
);
